<template>
  <div class="text-start">
    <template v-if="trainingModuleContent">
      <QuizDropDown
        :label="$t('quiz.quiz')"
        :value="trainingModuleContent.quizContent"
        @input="updateTrainingModuleContentQuizContent"
        :isEditing="isEditing"
        css-class="body-1 font-weight-medium textLight--text"
        class="mb-4"
      ></QuizDropDown>

      <!--trainingModuleContent duration-->
      <CourseNumberField
        :label="$t('course.courseDetails.contentDuration')"
        :value="trainingModuleContent.duration"
        @update:value="updateTrainingModuleContentDuration"
        :isEditing="isEditing"
        css-class="body-1 font-weight-medium textLight--text"
        class="mb-4"
      />

      <!--      <template>
        &lt;!&ndash;trainingModuleContent title&ndash;&gt;
        <v-row no-gutters class="mb-4">
          <v-col>
            <LocalisedContentEditable
              :values="trainingModuleContent.title"
              @update:values="updateTrainingModuleContentTitle"
              :placeholder="$t('course.courseDetails.contentNameHere')"
              :editable="isEditing"
              css-class="text-h6 font-weight-bold textLight&#45;&#45;text"
              :hasError="trainingModuleContent.hasInvalidTitle"
              :selectedLocale="selectedLocale"
            />
          </v-col>
        </v-row>

        &lt;!&ndash;trainingModuleContent duration&ndash;&gt;
        <CourseNumberField
          :label="$t('course.courseDetails.contentDuration')"
          :value="trainingModuleContent.duration"
          @update:value="updateTrainingModuleContentDuration"
          :isEditing="isEditing"
          css-class="body-1 font-weight-medium textLight&#45;&#45;text"
          class="mb-4"
        />

        &lt;!&ndash;trainingModuleContent description&ndash;&gt;
        <v-row no-gutters class="mb-4">
          <v-col>
            <LocalisedContentEditable
              :values="trainingModuleContent.description"
              @update:values="updateTrainingModuleContentDescription"
              :text-area-rows="5"
              :placeholder="$t('course.courseDetails.contentDescriptionHere')"
              :editable="isEditing"
              css-class="body-1 font-weight-light textLight&#45;&#45;text"
              :selectedLocale="selectedLocale"
            />
          </v-col>
        </v-row>

        <template>
          &lt;!&ndash;trainingModuleContent timeOut&ndash;&gt;
          <CourseNumberField
            :label="$t('course.courseDetails.contentTimeOut')"
            :value="quiz.timeOut"
            @update:value="updateTrainingModuleContentTimeOut"
            :isEditing="isEditing"
            css-class="body-1 font-weight-medium textLight&#45;&#45;text"
            class="mb-4"
          />

          &lt;!&ndash;trainingModuleContent passMark&ndash;&gt;
          <CourseNumberField
            :label="$t('course.courseDetails.contentPassMark')"
            :value="quiz.passMark"
            @update:value="updateTrainingModuleContentPassMark"
            :isEditing="isEditing"
            css-class="body-1 font-weight-medium textLight&#45;&#45;text"
            class="mb-4"
          />

          &lt;!&ndash;trainingModuleContent retryCount&ndash;&gt;
          <CourseNumberField
            :label="$t('course.courseDetails.contentRetryCount')"
            :value="quiz.retryCount"
            @update:value="updateTrainingModuleContentRetryCount"
            :isEditing="isEditing"
            css-class="body-1 font-weight-medium textLight&#45;&#45;text"
            class="mb-4"
          />
        </template>

        &lt;!&ndash;trainingModuleContent questionAnswers&ndash;&gt;
        <template>
          &lt;!&ndash;drag toggle switch&ndash;&gt;
          <v-row v-if="isEditing && questionAnswers.length > 1" justify="end">
            <v-col cols="auto">
              <div class="d-flex align-center">
              <span class="body-1 font-weight-medium textLight&#45;&#45;text px-3">
                {{ $t("reorder") }}
              </span>

                <v-switch
                  v-model="isDraggingEnabled"
                  inset
                  flat
                  hide-details
                  class="ma-0"
                  style="max-width: 44px"
                />
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <draggable
                v-model="questionAnswers"
                :disabled="!isEditing || !isDraggingEnabled"
                handle=".question-handle"
                @end="onDragEnd"
              >
                <v-row
                  v-for="(questionAnswer, questionAnswerIndex) in questionAnswers"
                  :key="`questionAnswer_${questionAnswerIndex}`"
                  no-gutters
                  class="mb-10"
                >
                  <v-col>
                    <QuizQuestionAnswer
                      :questionAnswer="questionAnswer"
                      :existingDisplayPositions="existingDisplayPositions"
                      :isEditing="isEditing && !isDraggingEnabled"
                      :selectedLocale="selectedLocale"
                      :isDraggable="isEditing && isDraggingEnabled"
                      @onUpdate="
                      updatedQuestionAnswer =>
                        updateTrainingModuleContentQuestionAnswers({
                          updatedQuestionAnswer,
                          questionAnswerIndex,
                        })
                    "
                      @onDelete="
                      updateTrainingModuleContentQuestionAnswers({
                        updatedQuestionAnswer: 'DELETE',
                        questionAnswerIndex,
                      })
                    "
                    />
                  </v-col>
                </v-row>
              </draggable>
            </v-col>
          </v-row>
        </template>

        &lt;!&ndash;training module content questionAnswer add button&ndash;&gt;
        <v-row v-if="isEditing && !isDraggingEnabled" no-gutters class="mt-12">
          <v-col>
            <v-btn
              depressed
              block
              color="button"
              class="
              subtitle-1
              font-weight-regular
              textLight&#45;&#45;text
              text-capitalize
              rounded-lg
            "
              @click="addQuestionAnswer"
            >
              <v-icon left size="20">mdi-plus</v-icon>

              {{ $t("course.courseDetails.addNewQuestion") }}
            </v-btn>
          </v-col>
        </v-row>
      </template>-->

      <!--trainingModuleContent delete button-->
      <v-row v-if="isEditing" justify="end">
        <v-col cols="auto">
          <v-btn
            small
            depressed
            color="#D75B5B"
            min-width="80"
            class="rounded-1 ms-2 white--text"
            :loading="isTrainingModuleContentDeleting"
            :disabled="isTrainingModuleContentSaving"
            @click="deleteTrainingModuleContent"
          >
            <v-icon small class="me-1">mdi-delete</v-icon>

            {{ $t("course.courseDetails.deleteModuleContent") }}
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
// import draggable from "vuedraggable";

// import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";
// import QuizQuestionAnswer from "@/app/quiz-module/components/details/QuizQuestionAnswer";
import CourseNumberField from "@/app/course-module/components/course-details/CourseNumberField";
import QuizDropDown from "@/app/quiz-module/components/QuizzesDropDown";

export default {
  name: "CourseContentQuiz",
  components: {
    QuizDropDown,
    // draggable,
    CourseNumberField,
    // LocalisedContentEditable,
    // QuizQuestionAnswer,
  },
  props: {
    training: {
      type: Object,
      required: true,
    },
    selectedTrainingModuleContent: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    selectedLocale: {
      type: String,
      default: "en",
    },
  },
  data() {
    return {
      questionAnswers: [],
      isTrainingModuleContentSaving: false,
      isTrainingModuleContentDeleting: false,
      isDraggingEnabled: false,
    };
  },
  computed: {
    trainingModuleContent() {
      return this.training.trainingModules[
        this.selectedTrainingModuleContent.trainingModuleIndex
      ]?.trainingModuleContents[
        this.selectedTrainingModuleContent.trainingModuleContentIndex
      ];
    },
    quiz() {
      return this.trainingModuleContent.quiz
        ? { ...this.trainingModuleContent.quiz }
        : {};
    },
    existingDisplayPositions() {
      return (
        this.questionAnswers?.reduce((result, item) => {
          if (item.displayPosition != null) {
            result.push(item.displayPosition);
          }

          return result;
        }, []) ?? []
      );
    },
  },
  watch: {
    quiz: {
      handler() {
        this.questionAnswers = this.quiz?.questionAnswers ?? [];
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    emitUpdateTraining(updateObject) {
      const clonedTraining = { ...this.training };

      if (updateObject === "DELETE") {
        clonedTraining.deletedTrainingModuleContents = [
          ...(clonedTraining.deletedTrainingModuleContents ?? []),
          clonedTraining.trainingModules[
            this.selectedTrainingModuleContent.trainingModuleIndex
          ]?.trainingModuleContents[
            this.selectedTrainingModuleContent.trainingModuleContentIndex
          ]?._id,
        ];

        clonedTraining.trainingModules[
          this.selectedTrainingModuleContent.trainingModuleIndex
        ].trainingModuleContents.splice(
          this.selectedTrainingModuleContent.trainingModuleContentIndex,
          1
        );

        this.$emit("update:training", clonedTraining);
        this.$emit("update:selectedTrainingModuleContent", null);
      } else {
        clonedTraining.trainingModules[
          this.selectedTrainingModuleContent.trainingModuleIndex
        ].trainingModuleContents[
          this.selectedTrainingModuleContent.trainingModuleContentIndex
        ] = {
          ...this.trainingModuleContent,
          ...updateObject,
        };

        this.$emit("update:training", clonedTraining);
      }
    },
    updateTrainingModuleContentQuizContent(value) {
      this.emitUpdateTraining({
        quizContent: value,
        hasChangesInQuizContent: true,
      });
    },
    updateTrainingModuleContentTitle(values) {
      this.emitUpdateTraining({
        title: values,
        hasChangesInTitle: true,
        hasInvalidTitle: !values?.find(x => x.value?.trim()?.length),
      });
    },
    updateTrainingModuleContentDuration(value) {
      this.emitUpdateTraining({
        duration: this.getInteger(value),
        hasChangesInDuration: true,
      });
    },
    updateTrainingModuleContentDescription(values) {
      this.emitUpdateTraining({
        description: values,
        hasChangesInDescription: true,
      });
    },
    updateTrainingModuleContentTimeOut(value) {
      this.emitUpdateTraining({
        quiz: {
          ...this.quiz,
          timeOut: this.getInteger(value),
        },
        hasChangesInQuiz: true,
      });
    },
    updateTrainingModuleContentPassMark(value) {
      this.emitUpdateTraining({
        quiz: {
          ...this.quiz,
          passMark: this.getInteger(value),
        },
        hasChangesInQuiz: true,
      });
    },
    updateTrainingModuleContentRetryCount(value) {
      this.emitUpdateTraining({
        quiz: {
          ...this.quiz,
          retryCount: this.getInteger(value),
        },
        hasChangesInQuiz: true,
      });
    },
    addQuestionAnswer() {
      this.questionAnswers.push({
        choices: [...Array(4).keys()].map(x => ({
          key: (x + 1).toString(),
          hasInvalidChoice: true,
        })),
        // displayPosition: this.questionAnswers.length,//removed for dragging
        hasInvalidQuestion: true,
        hasInvalidChoices: true,
      });

      this.emitUpdateTraining({
        quiz: {
          ...this.quiz,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInQuiz: true,
      });
    },
    updateTrainingModuleContentQuestionAnswers({
      updatedQuestionAnswer,
      questionAnswerIndex,
    }) {
      if (updatedQuestionAnswer === "DELETE") {
        this.$dialog
          .confirm(
            this.$t(
              "course.courseDetails.confirmTrainingModuleContentQuestionDelete"
            )
          )
          .then(() => {
            this.questionAnswers.splice(questionAnswerIndex, 1);
          })
          .catch(_ => {});
      } else {
        updatedQuestionAnswer.choices?.forEach(ch => {
          ch.hasInvalidChoice = !ch.value?.find(x => x.value?.trim()?.length);
        });

        this.$set(this.questionAnswers, questionAnswerIndex, {
          ...updatedQuestionAnswer,
          hasInvalidQuestion: !updatedQuestionAnswer?.question?.find(
            x => x.value?.trim()?.length
          ),
          hasInvalidChoices: updatedQuestionAnswer?.choices?.some(
            ch => ch.hasInvalidChoice
          ),
        });
      }

      this.emitUpdateTraining({
        quiz: {
          ...this.quiz,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInQuiz: true,
      });
    },
    onDragEnd(evt) {
      this.emitUpdateTraining({
        quiz: {
          ...this.quiz,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInQuiz: true,
      });
    },
    deleteTrainingModuleContent() {
      if (this.isTrainingModuleContentDeleting) return;

      this.$dialog
        .confirm(
          this.$t("course.courseDetails.confirmTrainingModuleContentDelete")
        )
        .then(() => {
          this.emitUpdateTraining("DELETE");
        })
        .catch(_ => {});
    },
  },
};
</script>

<style lang="scss" scoped />
